var exports = {
  "$q": "MonaFooterGrid__XrQDOm",
  "rw": "Rect__J0r5se",
  "zj": "RepositoryPanel__aloCEP",
  "OT": "RepositoryContent___s_0Am",
  "Ae": "RepositoryName__v_Oz9-",
  "hg": "RepositoryDescription__XmIaio",
  "Wd": "RepositoryStars__rtQAbq",
  "tk": "RepositoryNameText__qSvci4",
  "_H": "GrayTile__M_WxSh",
  "Mf": "ColorTile__rPIku_",
  "LL": "HoverTile__frVi87",
  "j_": "NeighborTile__twq9fz",
};

module.exports = exports;
